import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { onboardingFeatureKey } from './onboarding.actions';
import { onboardingReducers } from './onboarding.reducers';
import { OnboardingEffects } from './onboarding.effects';
import { OnboardingFacade } from './onboarding.facade';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(onboardingFeatureKey, onboardingReducers),
    EffectsModule.forFeature([OnboardingEffects]),
  ],
  providers: [OnboardingFacade],
})
export class OnboardingStoreModule { }
